module.exports = __webpack_public_path__ + "dc3b4eb967cf947f5cb06fdc94660a78.pdf";